package pl.michal_cyran.brand_hub

import com.varabyte.kobweb.compose.css.Background
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.functions.RadialGradient
import com.varabyte.kobweb.compose.css.functions.radialGradient
import com.varabyte.kobweb.compose.css.functions.toImage
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.layout.HorizontalDividerStyle
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariantBase
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.extendedBy
import com.varabyte.kobweb.silk.style.selectors.before
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.selectors.visited
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import com.varabyte.kobweb.silk.theme.modifyStyleBase
import org.jetbrains.compose.web.css.*

@InitSilk
fun initSiteStyles(ctx: InitSilkContext) {
    // This site does not need scrolling itself, but this is a good demonstration for how you might enable this in your
    // own site. Note that we only enable smooth scrolling unless the user has requested reduced motion, which is
    // considered a best practice.
    ctx.stylesheet.registerStyle("html") {
        cssRule(CSSMediaQuery.MediaFeature("prefers-reduced-motion", StylePropertyValue("no-preference"))) {
            Modifier
                .scrollBehavior(ScrollBehavior.Smooth)
        }
    }

    ctx.stylesheet.registerStyleBase("body") {
        Modifier
            .fontFamily("Inter", "-apple-system", "BlinkMacSystemFont", "sans-serif")
//            .fontFamily(
//                "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
//                "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "sans-serif"
//            )
            .fontSize(18.px)
            .lineHeight(1.5)
    }

    // Silk dividers only extend 90% by default; we want full width dividers in our site
    ctx.theme.modifyStyleBase(HorizontalDividerStyle) {
        Modifier.fillMaxWidth()
    }

    ctx.stylesheet.registerStyleBase("h1") {
        Modifier
            .fontWeight(800)
            .fontSize(3.cssRem)
            .lineHeight(2.5.cssRem)
            .margin(top = 12.px, bottom = 2.cssRem)
    }

    ctx.stylesheet.registerStyleBase("h2") {
        Modifier
            .fontWeight(700)
            .fontSize(2.cssRem)
            .lineHeight(1.5.cssRem)
    }

    ctx.stylesheet.registerStyleBase("h3") {
        Modifier
            .fontWeight(700)
            .fontSize(1.5.cssRem)
            .lineHeight(2.cssRem)
    }

    ctx.stylesheet.registerStyleBase("h6") {
        Modifier
            .fontWeight(700)
            .fontSize(1.cssRem)
            .lineHeight(1.cssRem)
            .margin(0.px)
            .textTransform(TextTransform.Uppercase)
    }

//    ctx.stylesheet.registerStyle("a") {
//        base {
//            Modifier
//                .color(colorMode)
//                .border(width = 0.px)
//        }
//
//        visited {
//            Modifier
//                .color(SitePalettes.dark.brand.primary)
//        }
//    }
}

val HeadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(3.cssRem)
        .textAlign(TextAlign.Start)
        .lineHeight(1.2) //1.5x doesn't look as good on very large text
}

val SubheadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(1.cssRem)
        .textAlign(TextAlign.Start)
        .color(colorMode.toPalette().color.toRgb().copyf(alpha = 0.8f))
}

val CircleButtonVariant = ButtonStyle.addVariantBase {
    Modifier.padding(0.px).borderRadius(50.percent)
}

val UncoloredButtonVariant = ButtonStyle.addVariantBase {
    Modifier.setVariable(ButtonVars.BackgroundDefaultColor, Colors.Transparent)
}


val BaseCardStyle = CssStyle {
    base {
        Modifier
            .borderRadius(24.px)
            .gap(1.cssRem)
            .padding(topBottom = 1.cssRem, leftRight = 1.5.cssRem)
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().borderDefault)
//            .boxShadow(
//                colorMode.toSitePalette().backgroundCardShadow
//            )
            .position(Position.Relative)
            .overflow(Overflow.Hidden)
            .transition(Transition.of("all", 0.4.s, TransitionTimingFunction.cubicBezier(0.4, 0.0, 0.2, 1.0)))
    }

    before {
        Modifier
            .content("")
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .right(0.px)
//            .height(200.px)
            .background(

//                Background.of(
//                    image = radialGradient(RadialGradient.Shape.Circle, CSSPosition.Top) {
//                        add(com.varabyte.kobweb.compose.ui.graphics.Color.rgba(6, 182, 212, 0.15f))
//                        add(Colors.Transparent, 70.percent)
//                    }.toImage()
//                )
            )
            .pointerEvents(PointerEvents.None)
    }
    hover {
        Modifier
            .transform { translateY((-8).px) }
            .border { color(colorMode.toSitePalette().borderHover) }
//            .boxShadow(
//                colorMode.toSitePalette().backgroundCardHoverShadow
//            )
    }

    cssRule(" h2") {
        Modifier
            .fontSize(2.cssRem)
            .fontWeight(700)
            .textShadow(0.px, 2.px, 10.px, Color.rgba(0, 0, 0, 0.3f))
    }

    cssRule(" h4") {
        Modifier
            .margin(top = 0.px)
    }

    cssRule(" p") {
        Modifier
            .color(colorMode.toSitePalette().textBody)
    }

    cssRule(" *") {
        Modifier
            .padding(0.px)
            .margin(0.px)
    }
}

val CardStyle = BaseCardStyle.extendedBy {
    base {
        Modifier
            .background(
                colorMode.toSitePalette().cardBg
            )
    }
    before {
        Modifier
            .background(

//                Background.of(
//                    image = radialGradient(RadialGradient.Shape.Circle, CSSPosition.Top) {
//                        add(com.varabyte.kobweb.compose.ui.graphics.Color.rgba(6, 182, 212, 0.15f))
//                        add(Colors.Transparent, 70.percent)
//                    }.toImage()
//                )
            )
    }
    hover {
        Modifier
//            .boxShadow(
//                colorMode.toSitePalette().backgroundCardHoverShadow
//            )
    }

    cssRule(" h2") {
        Modifier
            .textShadow(0.px, 2.px, 10.px, Color.rgba(0, 0, 0, 0.3f))
    }

    cssRule(" :is(h1, h2, h3, h4, h5, h6)") {
        Modifier
            .color(colorMode.toSitePalette().primaryMuted)
    }

    cssRule(" p") {
        Modifier
            .color(colorMode.toSitePalette().textBody)
    }
}


val FeaturedCardStyle = BaseCardStyle.extendedBy {

    base {
        Modifier
            .background(
                colorMode.toSitePalette().cardFeaturedBg
            )
    }
    before {
        Modifier
            .background(

//                Background.of(
//                    image = radialGradient(RadialGradient.Shape.Circle, CSSPosition.Top) {
//                        add(com.varabyte.kobweb.compose.ui.graphics.Color.rgba(6, 182, 212, 0.15f))
//                        add(Colors.Transparent, 70.percent)
//                    }.toImage()
//                )
            )
    }
    hover {
        Modifier
//            .boxShadow(
//                colorMode.toSitePalette().backgroundCardHoverShadow
//            )
    }

    cssRule(" h2") {
        Modifier
            .textShadow(0.px, 2.px, 10.px, Color.rgba(0, 0, 0, 0.3f))
    }

    cssRule(" :is(h1, h2, h3, h4, h5, h6)") {
        Modifier
            .color(colorMode.toSitePalette().textOnPrimary)
    }

    cssRule(" p") {
        Modifier
            .color(colorMode.toSitePalette().textOnPrimaryDim)
    }
}

val BigBadgeStyle = BaseCardStyle.extendedBy {
    base {
        Modifier
            .padding(topBottom = 1.cssRem, leftRight = 1.5.cssRem)
            .backgroundColor(colorMode.toSitePalette().badgeBg)
            .color(colorMode.toSitePalette().badgeText)
            .border(color = colorMode.toSitePalette().badgeBg, style = LineStyle.Solid, )
    }
}